import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Avatar, Table, Tooltip, Modal } from 'antd';
import moment from 'moment';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';

import './index.scss';

import { pageChanged } from '../../../../../data/redux/page_details/actions';
import * as botBuilderActions from '../../../../../data/redux/botbuilder_details/actions';

import { uniqueId, showMessage } from '../../../../../data/config/utils';
import { APP_PAGES, PERMISSIONS } from '../../../../../data/config/constants';
import { IMG_ERROR } from '../../../../../data/assets/img';

import PageHeaderLoader from '../../../../../components/pageheader/loaders';
import CardRowTableLoader from '../../../components/loaders/cardrowtable';
import ShowMessage from '../../../../../components/showmessage';
import CustomHeader from '../../../../../components/customheader';
import CommonForm from '../../../../../components/commonform';
import TableCellAction from '../../../components/tablecellaction';
import ErrorBoundary from '../../../../../components/errorboundary';

class Workflows extends Component {
  constructor(props) {
    super(props);
    this.columns = this.getWorkflowColumns();
    this.state = {
      modal_data: {
        title: "",
        show_edit_workflow: false,
        show_create_workflow: false,
      },
      current_workflow: null,
      search_text: "",
      filtered_workflows: props.botbuilder_details.workflows
    };
  }

  componentWillMount() {
    let { actions } = this.props;
    actions.pageChanged(APP_PAGES.WORKFLOWS, APP_PAGES.BOT_BUILDER);
  }

  componentDidMount() {
    if (isEmpty(this.props.botbuilder_details.workflows)) {
      this.props.actions.getWorkFlowData();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { botbuilder_details } = this.props;
    const { search_text } = this.state;

    if (!isEqual(nextProps.botbuilder_details.workflows, botbuilder_details.workflows)) {
      const table_data = [...nextProps.botbuilder_details.workflows];
      if (search_text.trim().length !== 0) {
        this.setState({
          filtered_workflows: this.filterWorkflowBySearchText(search_text, table_data)
        });
      } else {
        this.setState({
          filtered_workflows: table_data
        });
      }
    }
  }

  getWorkflowColumns = () => {
    const columns = [
      {
        title: 'Type',
        dataIndex: 'protected',
        key: 'protected',
        className: "ori-l-pad-15",
        render: bool => <Tooltip placement="right" overlayClassName="ori-font-xs ori-tooltip-arrow-hidden ori-tooltip-bg-white ori-tooltip-tag" title={<span>{bool ? "Protected workflow" : "Simple workflow"}</span>}><Avatar size="small" className={classNames({ "ori-bg-primary": !bool, "ori-bg-danger": bool })}>{bool ? "P" : "S"}</Avatar></Tooltip>
      },
      {
        title: 'Workflow Name',
        dataIndex: 'name',
        key: 'name',
        className: "ori-font-bold ori-capitalize-first",
        render: (name, record) => <span className="ori-link-primary" onClick={() => this.handleWorkflowClick(record)}>{name}</span>
      },
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'Last Updated',
        dataIndex: 'lastUpdated',
        key: 'lastUpdated',
        sorter: (t1, t2) => t1.lastUpdated - t2.lastUpdated,
        render: timestamp => <span>{moment(timestamp).format('DD MMM YYYY')}</span>
      },
      {
        title: 'Action',
        dataIndex: 'Action',
        key: 'Action',
        align: 'center',
        render: (text, record) => {
          if (record && !record.protected) {
            return (
              <TableCellAction align_center show_edit show_delete delete_popconfirm_title="Are you sure delete this workflow?" handleEditClick={() => this.handleEditWorkflow(record)} handleDeleteClick={() => this.handleDeleteWorkflow(record)} />
            );
          }
        }
      }
    ];
    return columns;
  };

  filterWorkflowBySearchText = (text, workflows) => {
    return workflows.filter((workflow) => {
      return (workflow && workflow.name && workflow.name !== undefined && workflow.name.toLowerCase().indexOf(text.toLowerCase()) !== -1 || workflow && workflow.description && workflow.description !== undefined && workflow.description.toLowerCase().indexOf(text.toLowerCase()) !== -1)
    });
  };

  handleWorkflowSearch = (event) => {
    const search_text = event.target.value;
    const { botbuilder_details } = this.props;
    this.setState({ search_text });
    if (search_text.trim().length !== 0) {
      this.setState({
        filtered_workflows: this.filterWorkflowBySearchText(search_text, botbuilder_details.workflows)
      });
    } else {
      this.setState({
        filtered_workflows: botbuilder_details.workflows
      });
    }
  };

  closeModal = () => {
    this.setState({
      current_workflow: null,
      modal_data: {
        title: "",
        show_edit_workflow: false,
        show_create_workflow: false,
      }
    });
  };

  handleCreateFormSubmit = () => {
    this.props.actions.createWorkflow(this.state.current_workflow);
    this.closeModal();
  };

  handleEditFormSubmit = () => {
    const { actions } = this.props;
    actions.updateWorkflow(this.state.current_workflow);
    this.closeModal();
  };

  handleCreateWorkflow = () => {
    const { isActionPermitted } = this.props;
    if (isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.CREATE)) {
      this.setState({
        current_workflow: {
          name: "",
          description: ""
        },
        modal_data: {
          ...this.state.modal_data,
          title: "Create Workflow",
          show_create_workflow: true,
        }
      });
    } else {
      showMessage('warning', 'you have not permission to create workflow');
    }
  };

  handleEditWorkflow = (workflow) => {
    const { isActionPermitted } = this.props;
    if (isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.UPDATE)) {
      this.setState({
        current_workflow: workflow,
        modal_data: {
          ...this.state.modal_data,
          title: "Edit Workflow",
          show_edit_workflow: true,
        }
      });
    } else {
      showMessage('warning', 'you have not permission to update workflow');
    }
  };

  handleDeleteWorkflow = (workflow) => {
    const { isActionPermitted } = this.props;
    if (isActionPermitted(PERMISSIONS.ACTIONS.WORKFLOW, PERMISSIONS.ACTION_TYPES.DELETE)) {
      const payload = { wid: workflow.wid };
      this.props.actions.deleteWorkflow(payload);
    } else {
      showMessage('warning', 'you have not permission to delete workflow');
    }
  };

  handleWorkflowClick = (workflow) => {
    const { history, match } = this.props;
    if (workflow && workflow.wid) {
      const path = `${match.path}/${workflow.wid}`;
      history.push(path);
    } else {
      showMessage('error', 'invalid workflow.');
    }
  };

  onChangeCurrentWorkflow = event => {
    this.setState({
      current_workflow: {
        ...this.state.current_workflow,
        [event.target.name]: event.target.value
      }
    });
  };

  renderWorkflowCommonForm = () => {
    const { modal_data, current_workflow } = this.state;
    if (modal_data.show_create_workflow || modal_data.show_edit_workflow) {
      const first_input_props = {
        title: "Name",
        placeholder: "Enter Workflow Name",
        name: "name",
        value: current_workflow.name,
        autoFocus: true,
        onChange: this.onChangeCurrentWorkflow,
      };
      const first_textarea_props = {
        title: "Description",
        placeholder: "Write description ...",
        value: current_workflow.description,
        name: "description",
        onChange: this.onChangeCurrentWorkflow,
      };
      const modal_footer_props = {
        button_ok_text: modal_data.show_create_workflow ? "Create" : "Update",
        handleCancelClick: this.closeModal,
        handleOkClick: modal_data.show_create_workflow ? this.handleCreateFormSubmit : this.handleEditFormSubmit
      };
      return (
        <ErrorBoundary onErrorCallback={this.closeModal}>
          <CommonForm first_input_props={first_input_props} first_textarea_props={first_textarea_props} modal_footer_props={modal_footer_props} show_first_input show_first_textarea />
        </ErrorBoundary>
      );
    }
  };

  render() {
    const { screen_width, botbuilder_details } = this.props;
    const { filtered_workflows, modal_data } = this.state;
    const mobile = screen_width < 768;
    if (botbuilder_details.loaders.workflows_loading && !botbuilder_details.loaders.workflows_loaded) {
      return (
        <div className="ori-full-parent-height">
          <PageHeaderLoader container_class="ori-lr-pad-10" bottom_bordered />
          <div className="ori-pad-10">
            <CardRowTableLoader />
          </div>
        </div>
      );
    } else if (!botbuilder_details.loaders.workflows_loading && botbuilder_details.loaders.workflows_loaded) {
      return (
        <div className="ori-lr-pad-10">
          <CustomHeader title="workflows" first_button_text="+ Add Workflow" first_button_type="primary" onClickFirstButton={this.handleCreateWorkflow} search_placeholder="Search Workflow" onChangeSearch={this.handleWorkflowSearch} bottom_bordered show_first_button show_search />
          <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} loading={botbuilder_details.loaders.workflows_loading} dataSource={filtered_workflows} columns={this.columns} />
          <Modal className="ori-modal-primary" title={modal_data.title} footer={null} visible={modal_data.show_edit_workflow || modal_data.show_create_workflow} maskClosable={false} onCancel={this.closeModal}>
            {this.renderWorkflowCommonForm()}
          </Modal>
        </div>
      );
    } else if (!botbuilder_details.loaders.workflows_loading && !botbuilder_details.loaders.workflows_loaded) {
      return (
        <ShowMessage img_src={IMG_ERROR} title="Error" message="unable to load workflow details. please check your intenet connection and reload the page." height={150} width={150} />
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = state => {
  return {
    screen_width: state.page_details.device_data.screen_width,
    botbuilder_details: state.botbuilder_details
  };
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(Object.assign({}, { pageChanged }, botBuilderActions), dispatch)
  };
}

Workflows.propTypes = {
  actions: PropTypes.object,
  history: PropTypes.object,
  match: PropTypes.object,
  botbuilder_details: PropTypes.object,
  screen_width: PropTypes.number,
  isActionPermitted: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps, null, { withRef: true })(Workflows);



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/workflows/index.js